<template>
  <div>
    <b-card header-tag="header" class="m-3" no-body>
      <template #header>
        <header-sagres titulo="Avisos a liberar" />
      </template>
      <b-table :busy="isBusy" :fields="fields" hover no-border-collapse :items="items" :sort-desc="true" striped small
        show-empty stacked="sm">
        <template #empty>
          <span>Não foram encontrados dados.</span>
        </template>
        <template #emptyfiltered>
          <span>Não foram encontrados dados.</span>
        </template>
        <template #table-busy>
          <div class="text-center text-dark">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="loading-text">Carregando...</strong>
          </div>
        </template>
        <template v-slot:cell(actions)="row">
          <div class="actions-icons">
            <b-link class="text-dark" @click="visualizarAviso(row.item.Id)">
              <font-awesome-icon icon="eye" />
              <div style="font-size: 12px">Ver detalhes</div>
            </b-link>
            <b-link class="text-dark" @click="abrirModalLiberarAviso(row.item)">
              <font-awesome-icon icon="check" />
              <div style="font-size: 12px">Liberar</div>
            </b-link>
            <b-link class="text-dark" @click="abrirModalDesativarAviso(row.item)">
              <font-awesome-icon icon="trash" />
              <div style="font-size: 12px">Desativar</div>
            </b-link>
          </div>
        </template>
      </b-table>
    </b-card>
    <b-modal id="liberar-aviso-modal" size="sm" button-size="sm" centered header-bg-variant="secondary"
      header-text-variant="light" header-class="" footer-class="" modal-class="p-2" no-close-on-backdrop
      no-close-on-esc>
      <template v-slot:modal-header="">
        <h5>Liberar aviso</h5>
      </template>
      Tem certeza que deseja liberar o aviso?
      <template v-slot:modal-footer="">
        <b-button size="sm" @click="liberarAviso()">
          Sim, liberar
        </b-button>
        <b-button size="sm" variant="outline-secondary" @click="fecharModalLiberarAviso()">
          Cancelar
        </b-button>
      </template>
    </b-modal>
    <modal-desativar-aviso v-if="mostrarModalDesativarAviso" :id-aviso="avisoSelecionado.Id"
      @fecharModalDesativarAviso="fecharModalDesativarAviso()" />
  </div>
</template>

<script lang="ts">
import messagesService from "@/services/messagesService";
import ModalDesativarAviso from "@/views/cadastro-avisos/ModalDesativarAviso.vue"
import { Component, Vue } from 'vue-property-decorator';
import { UtilsTS } from '@/utilsts';
import { mixins } from 'vue-class-component';
import { Aviso } from "@/types/avisos/aviso";
import { fieldsConsultaAvisos } from '@/types/avisos/fields-avisos';
import { TableField } from '@/types/table-field';
import HeaderSagres from '@/components/shared/HeaderSagres.vue';

const CompProps = Vue.extend({
  name: 'LiberarAvisos',
  components: { HeaderSagres, ModalDesativarAviso }
})

@Component
export default class LiberarAvisos extends mixins(UtilsTS, CompProps) {
  avisoSelecionado: Aviso | null = null
  isBusy = false
  fields: TableField[] = fieldsConsultaAvisos
  items: Aviso[] = []
  mostrarModalDesativarAviso = false

  async getAvisosALiberar(): Promise<void> {
    //console.log('LiberarAvisos.getAvisosALiberar')
    try {
      this.isBusy = true;
      this.items = await messagesService.getAvisosALiberar();
    } catch (err) {
      console.error("Erro ao pedir a lista de avisos a liberar: ", err);
      this.$toast.error(err.message);
    } finally {
      this.isBusy = false;
    }
  }
  abrirModalLiberarAviso(item) {
    this.avisoSelecionado = item
    this.$bvModal.show('liberar-aviso-modal')
  }
  fecharModalLiberarAviso() {
    this.avisoSelecionado = null,
      this.$bvModal.hide('liberar-aviso-modal')
  }
  abrirModalDesativarAviso(item) {
    this.avisoSelecionado = item
    this.mostrarModalDesativarAviso = true
  }
  async fecharModalDesativarAviso() {
    this.mostrarModalDesativarAviso = false
    await this.getAvisosALiberar()
  }
  async liberarAviso() {
    const response = await messagesService.liberarAviso(Number(this.avisoSelecionado?.Id))

    if (response && response.status == 200)
      this.$toast.success("Aviso liberado com sucesso")
    else
      this.$toast.error(response.data.msg || "Erro ao liberar o aviso")

    await this.getAvisosALiberar()
    this.fecharModalLiberarAviso()
  }
  visualizarAviso(id) {
    this.$router.push('/avisos/' + id)
  }
  async mounted() {
    await this.getAvisosALiberar();
  }
}
</script>

<style></style>